import { defineComponent, ref, onMounted,inject } from "/Scripts/vue.esm-browser.js";
import FastLink from "./FastLink.js";
import FooterBody from "./FooterBody.js";
import FooterBottom from "./FooterBottom.js";

const html = String.raw;

export default defineComponent({
    name: "Footer",
    props: {
        bbcSn: {
            type: Number,
            required: false,
        },
    },
    components: {
        FastLink,
        FooterBody,
        FooterBottom,
    },
    setup(props, { emit }) {
        const web = inject("web");
        //const getWebSite = () => {
        //    const hostname = window.location.hostname;

        //    if (hostname.startsWith("b2b.")) {
        //        return "b2b";
        //    } else if (hostname.includes("bbctour")) {
        //        return "bbc";
        //    } else if (hostname.startsWith("b2e.")) {
        //        return "b2e";
        //    }
        //    //localhost
        //    return props.webSite;
        //};

        //const webSite = ref(getWebSite());

        return {
            web
        };
    },
    template: html`
        <footer class="footer">
            <div class="contect">
                <fast-link :web-site="web"></fast-link>
                <footer-body :web-site="web" :bbc-sn="bbcSn"></footer-body>
                <footer-bottom :web-site="web"></footer-bottom>
            </div>
        </footer>
    `,
});
